var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMemberHelpMetalDeck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1, .cls-3, .cls-4, .cls-5, .cls-6 {\r\n        fill: none;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: silver;\r\n      }\r\n\r\n      .cls-3, .cls-4, .cls-5, .cls-6 {\r\n        stroke: #000;\r\n        stroke-linecap: round;\r\n        stroke-miterlimit: 10;\r\n      }\r\n\r\n      .cls-3 {\r\n        stroke-width: 1.34px;\r\n      }\r\n\r\n      .cls-4 {\r\n        stroke-width: 0.27px;\r\n      }\r\n\r\n      .cls-5 {\r\n        stroke-width: 0.47px;\r\n      }\r\n\r\n      .cls-6 {\r\n        stroke-width: 0.8px;\r\n      }\r\n\r\n      .cls-7 {\r\n        font-size: 8.82px;\r\n        font-family: ArialMT, Arial;\r\n      }\r\n    "))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "MemberHelpMetalDeck") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Boundary"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 256,
    height: 200
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "MemberMetalDeck"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "156.34 121.15 157.24 121.15 175.33 89.82 206.67 89.82 215.47 105.06 216.62 103.92 207.57 88.25 174.43 88.25 156.34 119.58 127.6 119.58 109.51 88.25 76.37 88.25 58.28 119.58 43.52 119.58 43.52 121.15 59.18 121.15 77.27 89.82 108.61 89.82 126.69 121.15 127.6 121.15 156.34 121.15"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 43.52,
    y1: 121.15,
    x2: 59.18,
    y2: 121.15
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 59.18,
    y1: 121.15,
    x2: 77.27,
    y2: 89.82
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 77.27,
    y1: 89.82,
    x2: 108.61,
    y2: 89.82
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 108.61,
    y1: 89.82,
    x2: 126.69,
    y2: 121.15
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 126.69,
    y1: 121.15,
    x2: 157.24,
    y2: 121.15
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 157.24,
    y1: 121.15,
    x2: 175.33,
    y2: 89.82
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 175.33,
    y1: 89.82,
    x2: 206.67,
    y2: 89.82
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 206.67,
    y1: 89.82,
    x2: 215.47,
    y2: 105.07
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 215.47,
    y1: 105.07,
    x2: 216.61,
    y2: 103.92
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 216.61,
    y1: 103.92,
    x2: 207.57,
    y2: 88.25
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 207.57,
    y1: 88.25,
    x2: 174.43,
    y2: 88.25
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 174.43,
    y1: 88.25,
    x2: 156.34,
    y2: 119.58
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 156.34,
    y1: 119.58,
    x2: 127.6,
    y2: 119.58
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 127.6,
    y1: 119.58,
    x2: 109.51,
    y2: 88.25
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 109.51,
    y1: 88.25,
    x2: 76.37,
    y2: 88.25
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 76.37,
    y1: 88.25,
    x2: 58.28,
    y2: 119.58
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 58.28,
    y1: 119.58,
    x2: 43.52,
    y2: 119.58
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 43.52,
    y1: 119.58,
    x2: 43.52,
    y2: 121.15
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 92.94,
    y1: 106.25,
    x2: 92.94,
    y2: 95.68
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 92.94,
    y1: 92.55,
    x2: 92.94,
    y2: 89.42
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 92.94,
    y1: 86.28,
    x2: 92.94,
    y2: 77.93
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 92.94,
    y1: 74.8,
    x2: 92.94,
    y2: 71.66
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 92.94,
    y1: 68.53,
    x2: 92.94,
    y2: 57.96
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 191,
    y1: 120.63,
    x2: 191,
    y2: 111.75
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 191,
    y1: 108.62,
    x2: 191,
    y2: 105.49
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 191,
    y1: 102.35,
    x2: 191,
    y2: 94
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 191,
    y1: 90.86,
    x2: 191,
    y2: 87.73
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 191,
    y1: 84.6,
    x2: 191,
    y2: 76.24
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 191,
    y1: 73.11,
    x2: 191,
    y2: 69.98
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 191,
    y1: 66.84,
    x2: 191,
    y2: 57.96
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 35.21,
    y1: 84.07,
    x2: 35.21,
    y2: 125.33
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 35.21,
    y1: 121.15,
    x2: 33.12,
    y2: 119.06
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 35.21,
    y1: 121.15,
    x2: 37.3,
    y2: 123.24
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 35.21,
    y1: 121.15,
    x2: 31.03,
    y2: 121.15
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 35.21,
    y1: 121.15,
    x2: 39.34,
    y2: 121.15
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 35.21,
    y1: 88.25,
    x2: 33.12,
    y2: 86.16
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 35.21,
    y1: 88.25,
    x2: 37.3,
    y2: 90.34
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 35.21,
    y1: 88.25,
    x2: 31.03,
    y2: 88.25
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 35.21,
    y1: 88.25,
    x2: 72.19,
    y2: 88.25
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-7",
    transform: "translate(32.51 116.31) rotate(-90)"
  }, "Depth"), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 88.76,
    y1: 61.77,
    x2: 195.18,
    y2: 61.77
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 191,
    y1: 61.77,
    x2: 188.91,
    y2: 63.86
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 191,
    y1: 61.77,
    x2: 193.09,
    y2: 59.68
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 191,
    y1: 61.77,
    x2: 191,
    y2: 57.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 191,
    y1: 61.77,
    x2: 191,
    y2: 63
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 92.94,
    y1: 61.77,
    x2: 90.85,
    y2: 63.86
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 92.94,
    y1: 61.77,
    x2: 95.03,
    y2: 59.68
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 92.94,
    y1: 61.77,
    x2: 92.94,
    y2: 57.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 92.94,
    y1: 61.77,
    x2: 92.94,
    y2: 63
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-7",
    transform: "translate(130.56 59.07)"
  }, "Width"), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 72.19,
    y1: 150.05,
    x2: 113.69,
    y2: 150.05
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 109.51,
    y1: 150.05,
    x2: 107.42,
    y2: 152.14
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 109.51,
    y1: 150.05,
    x2: 111.6,
    y2: 147.96
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 109.51,
    y1: 150.05,
    x2: 109.51,
    y2: 154.23
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 109.51,
    y1: 150.05,
    x2: 109.51,
    y2: 96.19
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 76.37,
    y1: 150.05,
    x2: 74.28,
    y2: 152.14
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 76.37,
    y1: 150.05,
    x2: 78.46,
    y2: 147.96
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 76.37,
    y1: 150.05,
    x2: 76.37,
    y2: 154.23
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 76.37,
    y1: 150.05,
    x2: 76.37,
    y2: 96.19
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-7",
    transform: "translate(85.39 136.92)"
  }, "Top"), /*#__PURE__*/React.createElement("text", {
    className: "cls-7",
    transform: "translate(84.69 147.02)"
  }, "flute"), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 122.52,
    y1: 150.05,
    x2: 161.42,
    y2: 150.05
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 157.24,
    y1: 150.05,
    x2: 155.15,
    y2: 152.14
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 157.24,
    y1: 150.05,
    x2: 159.33,
    y2: 147.96
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 157.24,
    y1: 150.05,
    x2: 157.24,
    y2: 154.23
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 157.24,
    y1: 150.05,
    x2: 157.24,
    y2: 125.33
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 126.69,
    y1: 150.05,
    x2: 124.61,
    y2: 152.14
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 126.69,
    y1: 150.05,
    x2: 128.78,
    y2: 147.96
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 126.69,
    y1: 150.05,
    x2: 126.69,
    y2: 154.23
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 126.69,
    y1: 150.05,
    x2: 126.69,
    y2: 125.33
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-7",
    transform: "translate(128.16 136.92)"
  }, "Bottom"), /*#__PURE__*/React.createElement("text", {
    className: "cls-7",
    transform: "translate(133.9 147.02)"
  }, "flute"), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 165.93,
    y1: 84.07,
    x2: 165.93,
    y2: 94
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 165.93,
    y1: 89.82,
    x2: 163.84,
    y2: 87.73
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 165.93,
    y1: 89.82,
    x2: 168.02,
    y2: 91.91
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 165.93,
    y1: 89.82,
    x2: 161.75,
    y2: 89.82
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 165.93,
    y1: 89.82,
    x2: 171.16,
    y2: 89.82
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 165.93,
    y1: 88.25,
    x2: 163.84,
    y2: 86.16
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 165.93,
    y1: 88.25,
    x2: 168.02,
    y2: 90.34
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 165.93,
    y1: 88.25,
    x2: 161.75,
    y2: 88.25
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 165.93,
    y1: 88.25,
    x2: 171.81,
    y2: 88.25
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-7",
    transform: "translate(120.46 92.3)"
  }, "Thickness"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMemberHelpMetalDeck);
export default __webpack_public_path__ + "static/media/MemberHelpMetalDeck.a1b68ff7df76bc0b3b6dc246b1f9e01e.svg";
export { ForwardRef as ReactComponent };